<template>
    <div class="offcanvas main-menu-offcanvas offcanvas-end" tabindex="-1" id="menuOffcanvas" aria-labelledby="menuOffcanvasLabel">
            <div class="offcanvas-header">
                <a id="menuOffcanvasLabel" class="navbar-brand" href="index.html"><img class="img-fluid" src="/assets/images/logo.svg" alt="logo" /></a>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="offcanvas-body lenis-scroll-disable">
                <div class="body-inner">
                    <nav class="navbar">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Home</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="index.html">Home 01</a></li>
                                    <li><a class="dropdown-item" href="index-02.html">Home 02</a></li>
                                    <li><a class="dropdown-item" href="index-03.html">Home 03</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Pages</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item active" href="about-us.html">About Us</a></li>
                                    <li><a class="dropdown-item" href="pricing.html">Pricing</a></li>
                                    <li><a class="dropdown-item" href="careers.html">Careers</a></li>
                                    <li><a class="dropdown-item" href="contact-us.html">Contact</a></li>
                                    <li><a class="dropdown-item" href="faq.html">Faq</a></li>
                                    <li><a class="dropdown-item" href="team.html">Team</a></li>
                                    <li><a class="dropdown-item" href="team-single.html">Team Single</a></li>
                                    <li><a class="dropdown-item" href="typography.html">Typography</a></li>
                                    <li><a class="dropdown-item" href="page-left-sidebar.html">Page Left Sidebar</a></li>
                                    <li><a class="dropdown-item" href="page-right-sidebar.html">Page Right Sidebar</a></li>
                                    <li><a class="dropdown-item" href="error-404.html">Error 404</a></li>
                                    <li><a class="dropdown-item" href="coming-soon.html">Coming Soon</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Service</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="service.html">Service</a></li>
                                    <li><a class="dropdown-item" href="service-detail.html">Service Single</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Case Studies</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="case-studies.html">Case Studies</a></li>
                                    <li><a class="dropdown-item" href="case-studies-detail.html">Case Studies Single</a></li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Blog</a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="blog.html">Blog Standard</a></li>
                                    <li><a class="dropdown-item" href="blog-detail.html">Blog Single</a></li>
                                </ul>
                            </li>
                            <li class="nav-item"><a class="nav-link" href="contact-us.html">Contact</a></li>
                        </ul>
                    </nav>
                    <div class="bottom-info">
                        <div class="contact-info">
                            <span class="number">+1 234 567 8910</span>
                            <a class="mail" href="#"><i class="fa-regular fa-envelope"></i>info@gmail.com</a>
                            <span class="text">Looking for collaboration for your next creative project?</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--=================================
      Header Side Panel -->
        <div class="offcanvas offcanvas-end sidepanel-offcanvas" tabindex="-1" id="offcanvasRight">
            <div class="offcanvas-header">
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>
            </div>

            <div class="offcanvas-body lenis-scroll-disable">
                <div class="body-inner">
                    <div class="about-info">
                        <h4 class="title mb-3">Scalable Business for Startups</h4>
                        <p>Get the oars in the water and start rowing. Execution is the single biggest factor in achievement so the faster and better your execution.</p>
                    </div>
                    <div class="socail-info">
                        <ul class="socail-list-item">
                            <li><a href="#"><i class="fa-brands fa-facebook-f"></i>Facebook</a></li>
                            <li><a href="#"><i class="fa-brands fa-instagram"></i>Instagram</a></li>
                            <li><a href="#"><i class="fa-brands fa-x-twitter"></i>Twitter</a></li>
                            <li><a href="#"><i class="fa-brands fa-dribbble"></i>Dribbble</a></li>
                        </ul>
                    </div>
                    <div class="contact-info">
                        <span class="number">+1 234 567 8910</span>
                        <a class="mail" href="#"><i class="fa-regular fa-envelope"></i>info@gmail.com</a>
                        <span class="text">Looking for collaboration for your next creative project?</span>
                    </div>
                </div>
            </div>
        </div>


        <div class="site-content">

            <div class="container-fluid">
                <div class="item-efftect">
                    <div class="efftect overflow-hidden"></div>
                    <div class="efftect overflow-hidden"></div>
                    <div class="efftect overflow-hidden"></div>
                    <div class="efftect overflow-hidden"></div>
                    <div class="efftect overflow-hidden"></div>
                </div>
            </div>

            <!--=================================
        Page Header -->
            <div class="inner-header bg-holder" style="background-image: url(/assets/images/banner/inner-header/page-header-01.jpg);">
                <div class="container">
                    <div class="row  justify-content-center">
                        <div class="col-md-12 text-center">
                            <h1 class="title">About ITinfinite</h1>
                            <p>Our Expertise. Know more about what we do</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-wrapper">

                <!--=================================
          About Info -->
                <section class="space-pt z-index-2">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-lg-7 mb-5 mb-lg-0">
                                <div class="section-title pb-0 pb-lg-4">
                                    <span class="sub-title"><img class="img-fluid" src="/assets/images/subtitle-icon.png" alt=""> About Us</span>
                                    <h2 class="title"> Your experience is everything to us </h2>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <img class="img-fluid" src="/assets/images/about/about-03.jpg" alt="#">
                                    </div>
                                    <div class="col-sm-8">
                                        <p class="ps-lg-3 mt-4 mt-sm-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                                        <div class="d-flex justify-content-center mt-5 ms-sm-5 ms-0">
                                            <a class="btn btn-effect" href="#">
                        <span>About Us</span>
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_59_253)"><path d="M19.4854 11.4293L17.0513 12.221C13.1214 13.4993 10.3036 16.9595 9.84784 21.0668C9.49371 16.981 6.71926 13.5081 2.81255 12.2604L0.210283 11.4293" stroke="white" stroke-width="2"/><path d="M9.83594 20.8889L9.83594 0" stroke="white" stroke-width="2"/></g><defs><clipPath id="clip0_59_253"><rect width="21.3333" height="20" fill="white" transform="translate(20) rotate(90)"/></clipPath></defs></svg>
                       </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4 mt-sm-5">
                                    <div class="col-sm-6">
                                        <div class="counter counter-style-1">
                                            <div class="counter-number"><span class="timer mb-0" data-to="240" data-speed="2000">240</span><span class="suffix">+</span></div>
                                            <div class="counter-info"><span class="counter-title">Business Peoples</span></div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="counter counter-style-1">
                                            <div class="counter-number"><span class="timer mb-0" data-to="100" data-speed="2000">100</span><span class="suffix">%</span></div>
                                            <div class="counter-info"><span class="counter-title">Customer Satisfaction</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <img class="img-fluid ps-lg-5" src="/assets/images/about/about-01.jpg" alt="#">
                            </div>
                        </div>
                    </div>
                </section>
                <!--=================================
          About Info -->

                <!--=================================
          Client Logo -->
                <div class="space-ptb ">
                    <div class="container-fluid p-0">
                        <div class="row g-0">
                            <div class="col-md-12">
                                <div class="marquee-wrapper">
                                    <div class="marquee-inner">
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon1.png" alt="" /></span>
                                            <span class="title">Web Design</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon2.png" alt="" /></span>
                                            <span class="title">UI/UX Design</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon3.png" alt="" /></span>
                                            <span class="title">Developer</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon4.png" alt="" /></span>
                                            <span class="title">ISO Developer</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon5.png" alt="" /></span>
                                            <span class="title">Digital Agency</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon1.png" alt="" /></span>
                                            <span class="title">Web Design</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon2.png" alt="" /></span>
                                            <span class="title">UI/UX Design</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon3.png" alt="" /></span>
                                            <span class="title">Developer</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon4.png" alt="" /></span>
                                            <span class="title">ISO Developer</span>
                                        </div>
                                        <div class="marquee-item">
                                            <span class="icon"><img class="img-fluid" src="/assets/images/client-logo/brand-icon5.png" alt="" /></span>
                                            <span class="title">Digital Agency</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--=================================
          Client Logo -->

                <!--=================================
          History -->
                <section class="space-pt bg-black ellipse-top">
                    <div class="space-pb ellipse-bottom">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-5">
                                    <div class="sticky-top" style="top: 80px;">
                                        <div class="section-title mb-0">
                                            <span class="sub-title"><img class="img-fluid" src="/assets/images/subtitle-icon.png" alt="" /> Our History</span>
                                            <h2 class="title">Our History</h2>
                                        </div>
                                        <p class="mb-5 mb-lg-0 ms-lg-5">Positive pleasure-oriented goals are much more powerful motivators than negative fear-based ones. Although each is successful separately, the right combination of both is the most powerful motivational force known
                                            to humankind.</p>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="history-wrapper">
                                        <div class="history-year-sm">2021</div>
                                        <div class="history-info">
                                            <div class="history-year-lg">2021</div>
                                            <div class="history-content">
                                                <p>They often mean leaving the perception of security in order to discover your personal freedom. These are the changes that will bring happiness and satisfaction into your life. Just go there now.</p>
                                                <blockquote>10 years out… having made a decade of changes. Imagine living the life you want to live.</blockquote>
                                                <p>The best way is to develop and follow a plan. Start with your goals in mind and then work backwards to develop the plan. What steps are required to get you to the goals? Make the plan as detailed as possible.
                                                    Try to visualize and then plan for, every possible setback.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="history-wrapper mt-4 mb-4">
                                        <div class="history-year-sm">2022</div>
                                        <div class="history-info">
                                            <div class="history-year-lg">2022</div>
                                            <div class="history-content">
                                                <p>They often mean leaving the perception of security in order to discover your personal freedom. These are the changes that will bring happiness and satisfaction into your life. Just go there now.</p>
                                                <blockquote>10 years out… having made a decade of changes. Imagine living the life you want to live.</blockquote>
                                                <p>The best way is to develop and follow a plan. Start with your goals in mind and then work backwards to develop the plan. What steps are required to get you to the goals? Make the plan as detailed as possible.
                                                    Try to visualize and then plan for, every possible setback.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="history-wrapper mt-4 mb-4">
                                        <div class="history-year-sm">2023</div>
                                        <div class="history-info">
                                            <div class="history-year-lg">2023</div>
                                            <div class="history-content">
                                                <p>They often mean leaving the perception of security in order to discover your personal freedom. These are the changes that will bring happiness and satisfaction into your life. Just go there now.</p>
                                                <blockquote>10 years out… having made a decade of changes. Imagine living the life you want to live.</blockquote>
                                                <p>The best way is to develop and follow a plan. Start with your goals in mind and then work backwards to develop the plan. What steps are required to get you to the goals? Make the plan as detailed as possible.
                                                    Try to visualize and then plan for, every possible setback.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="history-wrapper">
                                        <div class="history-year-sm">2024</div>
                                        <div class="history-info">
                                            <div class="history-year-lg">2024</div>
                                            <div class="history-content">
                                                <p>They often mean leaving the perception of security in order to discover your personal freedom. These are the changes that will bring happiness and satisfaction into your life. Just go there now.</p>
                                                <blockquote>10 years out… having made a decade of changes. Imagine living the life you want to live.</blockquote>
                                                <p>The best way is to develop and follow a plan. Start with your goals in mind and then work backwards to develop the plan. What steps are required to get you to the goals? Make the plan as detailed as possible.
                                                    Try to visualize and then plan for, every possible setback.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--=================================
          History -->

                <!--=================================
          Our Staff -->
                <section class="space-ptb bg-black z-index-2">
                    <div class="container">
                        <div class="row">
                            <div class="col-xxl-6 col-lg-8">
                                <div class="section-title mb-lg-0">
                                    <span class="sub-title"><img class="img-fluid" src="/assets/images/subtitle-icon.png" alt=""> Our Staff</span>
                                    <h2 class="title mb-0">Our team is friendly, talkative, and fully reliable.</h2>
                                </div>
                            </div>
                            <div class="col-xxl-6 col-lg-4 align-self-end">
                                <p class="mb-0 ps-xxl-5">So, make the decision to move forward. Commit your decision to paper, just to bring it into focus. Then, go for it!</p>
                            </div>
                        </div>

                        <div class="row mt-xl-5 pt-5">
                            <div class="col-md-12">
                                <div class="team-boxs grid-wrapper grid-xl-4 grid-lg-3 grid-md-2 grid-sm-2 grid-xs-1">
                                    <div class="team-item team-style-1">
                                        <div class="team-img">
                                            <img class="img-fluid" src="/assets/images/team/01.jpg" alt="" />
                                            <div class="image-overlay"><img class="img-fluid" src="/assets/images/team/symbol.png" alt="" /></div>
                                        </div>
                                        <div class="team-info">
                                            <a href="team-detail.html" class="team-title">Anne Smith</a>
                                            <span class="team-destination">Officer</span>
                                            <div class="team-social">
                                                <ul>
                                                    <li><a href="#">Fb</a></li>
                                                    <li><a href="#">Dr</a></li>
                                                    <li><a href="#">Tw</a></li>
                                                    <li><a href="#">Be</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-item team-style-1">
                                        <div class="team-img">
                                            <img class="img-fluid" src="/assets/images/team/02.jpg" alt="" />
                                            <div class="image-overlay"><img class="img-fluid" src="/assets/images/team/symbol.png" alt="" /></div>
                                        </div>
                                        <div class="team-info">
                                            <a href="team-detail.html" class="team-title">John Doe</a>
                                            <span class="team-destination">Director</span>
                                            <div class="team-social">
                                                <ul>
                                                    <li><a href="#">Fb</a></li>
                                                    <li><a href="#">Dr</a></li>
                                                    <li><a href="#">Tw</a></li>
                                                    <li><a href="#">Be</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-item team-style-1">
                                        <div class="team-img">
                                            <img class="img-fluid" src="/assets/images/team/03.jpg" alt="" />
                                            <div class="image-overlay"><img class="img-fluid" src="/assets/images/team/symbol.png" alt="" /></div>
                                        </div>
                                        <div class="team-info">
                                            <a href="team-detail.html" class="team-title">Mellissa Doe</a>
                                            <span class="team-destination">Analyst</span>
                                            <div class="team-social">
                                                <ul>
                                                    <li><a href="#">Fb</a></li>
                                                    <li><a href="#">Dr</a></li>
                                                    <li><a href="#">Tw</a></li>
                                                    <li><a href="#">Be</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="team-item team-style-1">
                                        <div class="team-img">
                                            <img class="img-fluid" src="/assets/images/team/04.jpg" alt="" />
                                            <div class="image-overlay"><img class="img-fluid" src="/assets/images/team/symbol.png" alt="" /></div>
                                        </div>
                                        <div class="team-info">
                                            <a href="team-detail.html" class="team-title">Paul Flavius</a>
                                            <span class="team-destination">Coordinator</span>
                                            <div class="team-social">
                                                <ul>
                                                    <li><a href="#">Fb</a></li>
                                                    <li><a href="#">Dr</a></li>
                                                    <li><a href="#">Tw</a></li>
                                                    <li><a href="#">Be</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <!--=================================
          Our Staff -->

                <!--=================================
          Our Testimonial -->
                <section class="space-pt testimonial-section overflow-hidden bg-black ellipse-top">
                    <div class="space-pb ellipse-bottom">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-md-10">
                                    <div class="section-title text-center">
                                        <span class="sub-title justify-content-center"><img class="img-fluid" src="/assets/images/subtitle-icon.png" alt=""> Our Testimonial</span>
                                        <h2 class="title"> Over 500 clients and 5,000 projects across the globe.</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-start">
                                <div class="col-md-11">
                                    <div class="owl-carousel slider-overflow" data-cursor-type="text" data-custom-text="Drag" data-nav-arrow="false" data-items="2" data-lg-items="1" data-md-items="1" data-sm-items="1" data-space="50">
                                        <div class="item">
                                            <div class="testimonial-wrapper testimonial-style-2">
                                                <div class="testimonial-ratings">
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-regular fa-star"></i>
                                                </div>
                                                <div class="testimonial-quote"><img class="img-fluid" src="/assets/images/quote-icon-01.png" alt="" /></div>
                                                <div class="testimonial-content">
                                                    <p>The IT-Hub database has been one of our current sources for recruitment, backed by a very experienced team who would go out of their way to make sure that requests are taken ahead.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <div class="author-info">
                                                        <h6 class="author-name">Key Benefits</h6>
                                                        <span class="author-position">Administrator</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="testimonial-wrapper testimonial-style-2">
                                                <div class="testimonial-ratings">
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-regular fa-star"></i>
                                                </div>
                                                <div class="testimonial-quote"><img class="img-fluid" src="/assets/images/quote-icon-01.png" alt="" /></div>
                                                <div class="testimonial-content">
                                                    <p>The IT-Hub database has been one of our current sources for recruitment, backed by a very experienced team who would go out of their way to make sure that requests are taken ahead.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <div class="author-info">
                                                        <h6 class="author-name">Joanna williams</h6>
                                                        <span class="author-position">Consultant</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="testimonial-wrapper testimonial-style-2">
                                                <div class="testimonial-ratings">
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-regular fa-star"></i>
                                                </div>
                                                <div class="testimonial-quote"><img class="img-fluid" src="/assets/images/quote-icon-01.png" alt="" /></div>
                                                <div class="testimonial-content">
                                                    <p>The IT-Hub database has been one of our current sources for recruitment, backed by a very experienced team who would go out of their way to make sure that requests are taken ahead.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <div class="author-info">
                                                        <h6 class="author-name">Anne Smith</h6>
                                                        <span class="author-position">Officer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="testimonial-wrapper testimonial-style-2">
                                                <div class="testimonial-ratings">
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-solid fa-star"></i>
                                                    <i class="fa-regular fa-star"></i>
                                                </div>
                                                <div class="testimonial-quote"><img class="img-fluid" src="/assets/images/quote-icon-01.png" alt="" /></div>
                                                <div class="testimonial-content">
                                                    <p>The IT-Hub database has been one of our current sources for recruitment, backed by a very experienced team who would go out of their way to make sure that requests are taken ahead.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <div class="author-info">
                                                        <h6 class="author-name">John Doe</h6>
                                                        <span class="author-position">Director</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--=================================
          Our Testimonial -->

            </div>
        </div>
</template>